import { useTranslation } from "react-i18next";
import Button from "./button";

const VideoTerm = ({ pageInfo, onNextStep }) => {
  const { t } = useTranslation();
  const [firstItem = {}] = pageInfo;

  return (
    <>
      <div className="table m-auto mb-8 mt-6">
        <img src={"https://cdn.firouzeh.com/public/bank-face.svg"} alt="face" />
      </div>
      <div className="px-5">
        <p className="body-14px-regular text-gray-0 ">
          با رعایت شئونات اسلامی و بدون ماسک مطابق دستورالعمل، از چهره خود به
          صورت سلفی ویدیو بگیرید و جمله پایین صفحه را به صورت رسا بخوانید .
        </p>
        <div className="bg-white rounded-lg px-3 py-4  w-full">
          <h4 className="body-14px-demibold text-gray-4 ">شرایط:</h4>
          <ul className="body-14px-regular">
            {firstItem?.infos?.map((item) => (
              <li
                className="relative pr-3 before:content-[''] before:absolute before:bg-primary--1 before:w-[6px] before:h-[6px] before:right-0 before:top-[10px] before:rotate-45"
                key={item}
              >
                {item.value}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <Button name={t("card-page.video-recording")} onNextStep={onNextStep} />
    </>
  );
};

export default VideoTerm;
